// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3mWah","amount":"Amount_amount__1xZio","tip":"Amount_tip__1bSRY","tipHeader":"Amount_tipHeader__2KUdC","tipsWrap":"Amount_tipsWrap__25lUh"};